import React from 'react'

export default () => (
  <svg width="33" height="43" viewBox="0 0 33 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 38.4936V4.61505C0 1.39218 3.6164 -0.507421 6.27002 1.32157L31.1603 18.4771C33.4837 20.0784 33.4632 23.5171 31.1211 25.0908L6.23074 41.8138C3.5735 43.5991 0 41.6949 0 38.4936Z" fill="white"/>
  </svg>
)
